export { isExternalResource, urlRefsAndTarget, typeMap } from './is-external-resource';
